<template>
  <div>
    <h3 class="text-center mb-3" tabindex="0">
      {{ title }}
      <slot></slot>
    </h3>
  </div>

  <div class="categories-wrapper">
    <div class="category-mobile-wrapping">
      <div class="category" tabindex="0">
        <div class="icon"></div>
        <div class="description">
          <h4>{{ titleHousehold }}</h4>
          <p>{{ descriptionHousehold }}</p>
        </div>
      </div>
      <div class="category" tabindex="0">
        <div class="icon travel"></div>
        <div class="description">
          <h4>{{ titleTravel }}</h4>
          <p>{{ descriptionTravel }}</p>
        </div>
      </div>
    </div>
    <div class="category-mobile-wrapping">
      <div class="category" tabindex="0">
        <div class="icon food"></div>
        <div class="description">
          <h4>{{ titleFood }}</h4>
          <p>{{ descriptionFood }}</p>
        </div>
      </div>
      <div class="category" tabindex="0">
        <div class="icon clothes"></div>
        <div class="description">
          <h4>{{ titleClothes }}</h4>
          <p>{{ descriptionClothes }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    title: {
      type: String,
      default: '~~~~',
    },
    titleHousehold: {
      type: String,
      default: '',
    },
    descriptionHousehold: {
      type: String,
      default: '',
    },
    titleTravel: {
      type: String,
      default: '',
    },
    descriptionTravel: {
      type: String,
      default: '',
    },
    titleFood: {
      type: String,
      default: '',
    },
    descriptionFood: {
      type: String,
      default: '',
    },
    titleClothes: {
      type: String,
      default: '',
    },
    descriptionClothes: {
      type: String,
      default: '',
    },
  },
};
</script>
